import { createContext } from "react";

const discountContext = createContext();

export default discountContext;
